import { useAppDispatch, useAppSelector } from 'src/hooks';
import Badge from '@mui/material/Badge';
import NotificationsIcon from '@mui/icons-material/Notifications';
import IconButton from '@mui/material/IconButton';
import React, { useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import moment from 'moment';
import Divider from '@mui/material/Divider';
import Menu from '@mui/material/Menu';
import { makeStyles } from '@material-ui/core';
import { Theme, Tooltip } from '@mui/material';
import { resetNotifications } from 'src/pages/core/websocket/store/notifications-slice';

const useStyles = makeStyles<Theme>(() => ({
  menu: {
    '&  li': {
      maxWidth: '320px'
    }
  }
}));

export default function Notifications() {
  const { notificationData, unreadNotificationCount } = useAppSelector(
    (state) => state.notifications
  );
  const appDispatch = useAppDispatch();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    if (unreadNotificationCount > 0) { appDispatch(resetNotifications()); }
  };

  return notificationData.length ? (
    <div>
      <Tooltip title='Notifications'>
        <IconButton
          onClick={handleClickListItem}
          id='lock-button'
          aria-controls={open ? 'lock-menu' : undefined}
          aria-haspopup='true'
          aria-expanded={open ? 'true' : undefined}
        >
          <Badge badgeContent={unreadNotificationCount} color='primary'>
            <NotificationsIcon />
          </Badge>
        </IconButton>
      </Tooltip>
      <Menu
        id='lock-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'lock-button'
        }}
        className={classes.menu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        {notificationData.map((data, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <MenuItem key={`p_${index}`}>
            <div
              className={
                !data.is_read
                  ? 'notification-menu unread_notification'
                  : 'notification-menu'
              }>
              <div
                style={{
                  fontSize: ' 12px',
                  fontWeight: '400',
                  display: 'block'
                }}
              >
                {data.message}
              </div>
              <div
                style={{
                  color: 'gray',
                  fontSize: '12px',
                  textAlign: 'right',
                  display: 'block'
                }}
              >
                {moment(data.updated_at).format('lll')}
              </div>
            </div>
            <Divider />
          </MenuItem>
        ))}
      </Menu>
    </div>
  ) : (
    <Tooltip title='Notifications'>
      <IconButton>
        <NotificationsIcon />
      </IconButton>
    </Tooltip>
  );
}
